import React, { Component } from "react";
import AbbreviatedMillionNumberFormat from "../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import { getRequest } from "../../../api/ApiService";
import { logError, detectMobile } from "../../../services/utils";

class VarianceAnalysis extends Component {
  constructor(props) {
    super(props);

    const isMobile = detectMobile();

    this.state = {
      expected: {},
      actual: {},
      roundInUrl: props.roundInUrl,
      currentRound: props.currentRound,
      rounds: props.rounds,
      totalRevenuesExpanded: isMobile,
      totalCostOfSalesExpanded: isMobile,
      grossProfitsExpanded: isMobile,
      netProfitsExpanded: isMobile
    };
  }

  expandTotalCostOfSales = () => {
    this.setState({
      totalCostOfSalesExpanded: true
    });
  };

  collapseTotalCostOfSales = () => {
    this.setState({
      totalCostOfSalesExpanded: false
    });
  };

  expandTotalRevenues = () => {
    this.setState({
      totalRevenuesExpanded: true
    });
  };

  collapseTotalRevenues = () => {
    this.setState({
      totalRevenuesExpanded: false
    });
  };

  expandGrossProfits = () => {
    this.setState({
      grossProfitsExpanded: true
    });
  };

  collapseGrossProfits = () => {
    this.setState({
      grossProfitsExpanded: false
    });
  };

  expandNetProfits = () => {
    this.setState({
      netProfitsExpanded: true
    });
  };

  collapseNetProfits = () => {
    this.setState({
      netProfitsExpanded: false
    });
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.roundInUrl !== nextProps.roundInUrl ||
      this.state.currentRound !== nextProps.currentRound ||
      (this.state.rounds.length === 0 && nextProps.rounds.length !== 0)
    ) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  getFinancialAnalysis() {
    const base_url = `${process.env.REACT_APP_API_URL}team/financial_analysis/`;
    const { currentRound, roundInUrl, rounds } = this.state;

    const maxRound = rounds[rounds.length - 1].number;
    let activeRound = currentRound + 1;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      activeRound = roundInUrl + 1;
    }

    if (activeRound > maxRound) {
      activeRound = maxRound;
    }

    return getRequest(`${base_url}?round_lte=${activeRound}`);
  }

  fetchData = () => {
    const { rounds } = this.state;

    if (rounds.length > 0) {
      this.getFinancialAnalysis()
        .then(res => {
          let actual = {};
          let expected = {};

          res.body.forEach(item => {
            if (item.is_actual === true) {
              actual[item.target_round_number] = item;
            } else {
              expected[item.target_round_number] = item;
            }
          });

          this.setState({
            actual,
            expected
          });
        })
        .catch(err => {
          logError(err, "VarianceAnalysis", "fetchData");
        });
    }
  };

  componentDidMount() {
    this.fetchData();
  }

  getActualYearParam(year, key) {
    if (year in this.state.actual) {
      let obj = this.state.actual[year];
      if (key in obj) {
        return obj[key];
      }
    }

    return 0;
  }

  getExpectedYearParam(year, key) {
    if (year in this.state.expected) {
      let obj = this.state.expected[year];
      if (key in obj) {
        return obj[key];
      }
    }

    return 0;
  }

  getDiffYearParam(year, key, before, after) {
    before = before || this.getExpectedYearParam(year, key);
    after = after || this.getActualYearParam(year, key);

    if (before === 0 || after === 0) {
      return 0;
    }

    const percent = ((after - before) / Math.abs(before)) * 100;

    return percent.toFixed(2);
  }

  /**
   * Expected values
   */
  getExpectedUnits(year) {
    return Math.abs(this.getExpectedYearParam(year, "units_sold"));
  }

  get expectedUnits1() {
    return this.getExpectedUnits(this.year1);
  }

  get expectedUnits2() {
    return this.getExpectedUnits(this.year2);
  }

  get expectedUnits3() {
    return this.getExpectedUnits(this.year3);
  }

  getExpectedAvgSellingPrice(year) {
    return this.getExpectedYearParam(year, "average_selling_price");
  }

  get expectedAvgSellingPrice1() {
    return this.getExpectedAvgSellingPrice(this.year1);
  }

  get expectedAvgSellingPrice2() {
    return this.getExpectedAvgSellingPrice(this.year2);
  }

  get expectedAvgSellingPrice3() {
    return this.getExpectedAvgSellingPrice(this.year3);
  }

  getExpectedTotalRevenues(year) {
    return this.getExpectedYearParam(year, "total_revenues");
  }

  get expectedTotalRevenues1() {
    return this.getExpectedTotalRevenues(this.year1);
  }

  get expectedTotalRevenues2() {
    return this.getExpectedTotalRevenues(this.year2);
  }

  get expectedTotalRevenues3() {
    return this.getExpectedTotalRevenues(this.year3);
  }

  getExpectedAvgUnitCosts(year) {
    return this.getExpectedYearParam(year, "average_unit_costs");
  }

  get expectedAvgUnitCosts1() {
    return this.getExpectedAvgUnitCosts(this.year1);
  }

  get expectedAvgUnitCosts2() {
    return this.getExpectedAvgUnitCosts(this.year2);
  }

  get expectedAvgUnitCosts3() {
    return this.getExpectedAvgUnitCosts(this.year3);
  }

  getExpectedTotalCostOfSales(year) {
    return this.getExpectedYearParam(year, "total_cost_goods_sold");
  }

  get expectedTotalCostOfSales1() {
    return this.getExpectedTotalCostOfSales(this.year1);
  }

  get expectedTotalCostOfSales2() {
    return this.getExpectedTotalCostOfSales(this.year2);
  }

  get expectedTotalCostOfSales3() {
    return this.getExpectedTotalCostOfSales(this.year3);
  }

  getExpectedGrossProfits(year) {
    return this.getExpectedYearParam(year, "gross_profits");
  }

  get expectedGrossProfits1() {
    return this.getExpectedGrossProfits(this.year1);
  }

  get expectedGrossProfits2() {
    return this.getExpectedGrossProfits(this.year2);
  }

  get expectedGrossProfits3() {
    return this.getExpectedGrossProfits(this.year3);
  }

  getExpectedOperatingExpenses(year) {
    return (
      this.getExpectedYearParam(year, "total_operating_costs") +
      this.getExpectedYearParam(year, "total_non_operating_costs")
    );
  }

  get expectedOperatingExpenses1() {
    return this.getExpectedOperatingExpenses(this.year1);
  }

  get expectedOperatingExpenses2() {
    return this.getExpectedOperatingExpenses(this.year2);
  }

  get expectedOperatingExpenses3() {
    return this.getExpectedOperatingExpenses(this.year3);
  }

  getExpectedNonOperatingExpenses(year) {
    return this.getExpectedYearParam(year, "total_non_operating_costs");
  }

  get expectedNonOperatingExpenses1() {
    return this.getExpectedNonOperatingExpenses(this.year1);
  }

  get expectedNonOperatingExpenses2() {
    return this.getExpectedNonOperatingExpenses(this.year2);
  }

  get expectedNonOperatingExpenses3() {
    return this.getExpectedNonOperatingExpenses(this.year3);
  }

  getExpectedTotalIncomeBeforeTaxes(year) {
    return this.getExpectedYearParam(year, "income_before_taxes");
  }

  get expectedTotalIncomeBeforeTaxes1() {
    return this.getExpectedTotalIncomeBeforeTaxes(this.year1);
  }

  get expectedTotalIncomeBeforeTaxes2() {
    return this.getExpectedTotalIncomeBeforeTaxes(this.year2);
  }

  get expectedTotalIncomeBeforeTaxes3() {
    return this.getExpectedTotalIncomeBeforeTaxes(this.year3);
  }

  getExpectedNetProfits(year) {
    return this.getExpectedYearParam(year, "net_income");
  }

  get expectedNetProfits1() {
    return this.getExpectedNetProfits(this.year1);
  }

  get expectedNetProfits2() {
    return this.getExpectedNetProfits(this.year2);
  }

  get expectedNetProfits3() {
    return this.getExpectedNetProfits(this.year3);
  }

  /**
   * Actual values
   */
  getActualUnits(year) {
    return Math.abs(this.getActualYearParam(year, "units_sold"));
  }

  get actualUnits1() {
    return this.getActualUnits(this.year1);
  }

  get actualUnits2() {
    return this.getActualUnits(this.year2);
  }

  get actualUnits3() {
    return this.getActualUnits(this.year3);
  }

  getActualAvgSellingPrice(year) {
    return this.getActualYearParam(year, "average_selling_price");
  }

  get actualAvgSellingPrice1() {
    return this.getActualAvgSellingPrice(this.year1);
  }

  get actualAvgSellingPrice2() {
    return this.getActualAvgSellingPrice(this.year2);
  }

  get actualAvgSellingPrice3() {
    return this.getActualAvgSellingPrice(this.year3);
  }

  getActualTotalRevenues(year) {
    return this.getActualYearParam(year, "total_revenues");
  }

  get actualTotalRevenues1() {
    return this.getActualTotalRevenues(this.year1);
  }

  get actualTotalRevenues2() {
    return this.getActualTotalRevenues(this.year2);
  }

  get actualTotalRevenues3() {
    return this.getActualTotalRevenues(this.year3);
  }

  getActualAvgUnitCosts(year) {
    return this.getActualYearParam(year, "average_unit_costs");
  }

  get actualAvgUnitCosts1() {
    return this.getActualAvgUnitCosts(this.year1);
  }

  get actualAvgUnitCosts2() {
    return this.getActualAvgUnitCosts(this.year2);
  }

  get actualAvgUnitCosts3() {
    return this.getActualAvgUnitCosts(this.year3);
  }

  getActualTotalCostOfSales(year) {
    return this.getActualYearParam(year, "total_cost_goods_sold");
  }

  get actualTotalCostOfSales1() {
    return this.getActualTotalCostOfSales(this.year1);
  }

  get actualTotalCostOfSales2() {
    return this.getActualTotalCostOfSales(this.year2);
  }

  get actualTotalCostOfSales3() {
    return this.getActualTotalCostOfSales(this.year3);
  }

  getActualGrossProfits(year) {
    return this.getActualYearParam(year, "gross_profits");
  }

  get actualGrossProfits1() {
    return this.getActualGrossProfits(this.year1);
  }

  get actualGrossProfits2() {
    return this.getActualGrossProfits(this.year2);
  }

  get actualGrossProfits3() {
    return this.getActualGrossProfits(this.year3);
  }

  getActualOperatingExpenses(year) {
    return (
      this.getActualYearParam(year, "total_operating_costs") +
      this.getActualYearParam(year, "total_non_operating_costs")
    );
  }

  get actualOperatingExpenses1() {
    return this.getActualOperatingExpenses(this.year1);
  }

  get actualOperatingExpenses2() {
    return this.getActualOperatingExpenses(this.year2);
  }

  get actualOperatingExpenses3() {
    return this.getActualOperatingExpenses(this.year3);
  }

  getActualNonOperatingExpenses(year) {
    return this.getActualYearParam(year, "total_non_operating_costs");
  }

  get actualNonOperatingExpenses1() {
    return this.getActualNonOperatingExpenses(this.year1);
  }

  get actualNonOperatingExpenses2() {
    return this.getActualNonOperatingExpenses(this.year2);
  }

  get actualNonOperatingExpenses3() {
    return this.getActualNonOperatingExpenses(this.year3);
  }

  getActualTotalIncomeBeforeTaxes(year) {
    return this.getActualYearParam(year, "income_before_taxes");
  }

  get actualTotalIncomeBeforeTaxes1() {
    return this.getActualTotalIncomeBeforeTaxes(this.year1);
  }

  get actualTotalIncomeBeforeTaxes2() {
    return this.getActualTotalIncomeBeforeTaxes(this.year2);
  }

  get actualTotalIncomeBeforeTaxes3() {
    return this.getActualTotalIncomeBeforeTaxes(this.year3);
  }

  getActualNetProfits(year) {
    return this.getActualYearParam(year, "net_income");
  }

  get actualNetProfits1() {
    return this.getActualNetProfits(this.year1);
  }

  get actualNetProfits2() {
    return this.getActualNetProfits(this.year2);
  }

  get actualNetProfits3() {
    return this.getActualNetProfits(this.year3);
  }

  /**
   * Diff values
   */
  getDiffUnits(year) {
    return this.getDiffYearParam(
      null,
      null,
      this.getExpectedUnits(year),
      this.getActualUnits(year)
    );
  }

  get diffUnits1() {
    return this.getDiffUnits(this.year1);
  }

  get diffUnits2() {
    return this.getDiffUnits(this.year2);
  }

  get diffUnits3() {
    return this.getDiffUnits(this.year3);
  }

  getDiffAvgSellingPrice(year) {
    return this.getDiffYearParam(year, "average_selling_price");
  }

  get diffAvgSellingPrice1() {
    return this.getDiffAvgSellingPrice(this.year1);
  }

  get diffAvgSellingPrice2() {
    return this.getDiffAvgSellingPrice(this.year2);
  }

  get diffAvgSellingPrice3() {
    return this.getDiffAvgSellingPrice(this.year3);
  }

  getDiffTotalRevenues(year) {
    return this.getDiffYearParam(year, "total_revenues");
  }

  get diffTotalRevenues1() {
    return this.getDiffTotalRevenues(this.year1);
  }

  get diffTotalRevenues2() {
    return this.getDiffTotalRevenues(this.year2);
  }

  get diffTotalRevenues3() {
    return this.getDiffTotalRevenues(this.year3);
  }

  getDiffAvgUnitCosts(year) {
    return -1 * this.getDiffYearParam(year, "average_unit_costs");
  }

  get diffAvgUnitCosts1() {
    return this.getDiffAvgUnitCosts(this.year1);
  }

  get diffAvgUnitCosts2() {
    return this.getDiffAvgUnitCosts(this.year2);
  }

  get diffAvgUnitCosts3() {
    return this.getDiffAvgUnitCosts(this.year3);
  }

  getDiffTotalCostOfSales(year) {
    return this.getDiffYearParam(year, "total_cost_goods_sold");
  }

  get diffTotalCostOfSales1() {
    return this.getDiffTotalCostOfSales(this.year1);
  }

  get diffTotalCostOfSales2() {
    return this.getDiffTotalCostOfSales(this.year2);
  }

  get diffTotalCostOfSales3() {
    return this.getDiffTotalCostOfSales(this.year3);
  }

  getDiffGrossProfits(year) {
    return this.getDiffYearParam(year, "gross_profits");
  }

  get diffGrossProfits1() {
    return this.getDiffGrossProfits(this.year1);
  }

  get diffGrossProfits2() {
    return this.getDiffGrossProfits(this.year2);
  }

  get diffGrossProfits3() {
    return this.getDiffGrossProfits(this.year3);
  }

  getDiffOperatingExpenses(year) {
    return this.getDiffYearParam(
      null,
      null,
      this.getExpectedOperatingExpenses(year),
      this.getActualOperatingExpenses(year)
    );
  }

  get diffOperatingExpenses1() {
    return this.getDiffOperatingExpenses(this.year1);
  }

  get diffOperatingExpenses2() {
    return this.getDiffOperatingExpenses(this.year2);
  }

  get diffOperatingExpenses3() {
    return this.getDiffOperatingExpenses(this.year3);
  }

  getDiffNonOperatingExpenses(year) {
    return this.getDiffYearParam(year, "total_non_operating_costs");
  }

  get diffNonOperatingExpenses1() {
    return this.getDiffNonOperatingExpenses(this.year1);
  }

  get diffNonOperatingExpenses2() {
    return this.getDiffNonOperatingExpenses(this.year2);
  }

  get diffNonOperatingExpenses3() {
    return this.getDiffNonOperatingExpenses(this.year3);
  }

  getDiffTotalIncomeBeforeTaxes(year) {
    return this.getDiffYearParam(year, "income_before_taxes");
  }

  get diffTotalIncomeBeforeTaxes1() {
    return this.getDiffTotalIncomeBeforeTaxes(this.year1);
  }

  get diffTotalIncomeBeforeTaxes2() {
    return this.getDiffTotalIncomeBeforeTaxes(this.year2);
  }

  get diffTotalIncomeBeforeTaxes3() {
    return this.getDiffTotalIncomeBeforeTaxes(this.year3);
  }

  getDiffNetProfits(year) {
    return this.getDiffYearParam(year, "net_income");
  }

  get diffNetProfits1() {
    return this.getDiffNetProfits(this.year1);
  }

  get diffNetProfits2() {
    return this.getDiffNetProfits(this.year2);
  }

  get diffNetProfits3() {
    return this.getDiffNetProfits(this.year3);
  }

  getYear(offset) {
    const { currentRound, roundInUrl, rounds } = this.state;

    let current_year = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_year = roundInUrl;
    }

    let result = [current_year - 1, current_year, current_year + 1];
    if (current_year === 1) {
      result = [current_year, current_year + 1, current_year + 2];
    } else if (current_year === rounds.length) {
      result = [current_year - 2, current_year - 1, current_year];
    }

    return result[offset];
  }

  get year1() {
    return this.getYear(0);
  }

  get year2() {
    return this.getYear(1);
  }

  get year3() {
    return this.getYear(2);
  }

  get currentYear() {
    const { currentRound, roundInUrl } = this.state;

    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    return current_round;
  }

  render() {
    return (
      <div className="panel-dashboard-white-full">
        <h5 className="title-sky-blue">VARIANCE ANALYSIS</h5>
        <div className="table-responsive">
          <table className="table border-analysis mb-20">
            <thead>
              <tr>
                <th className="table-title text-center">
                  <span></span>
                </th>
                <th
                  className={
                    "table-title text-center " +
                    (this.year1 === this.currentYear
                      ? "title-sky-blue"
                      : "title-gray")
                  }
                >
                  <span>YEAR {this.year1}</span>
                  {this.year1 === this.currentYear && (
                    <span className="block">(CURRENT YEAR)</span>
                  )}
                </th>
                <th
                  className={
                    "table-title text-center " +
                    (this.year2 === this.currentYear
                      ? "title-sky-blue"
                      : "title-gray")
                  }
                >
                  <span className="block">YEAR {this.year2}</span>
                  {this.year2 === this.currentYear && (
                    <span className="block">(CURRENT YEAR)</span>
                  )}
                </th>
                <th
                  className={
                    "table-title text-center border-right-none " +
                    (this.year3 === this.currentYear
                      ? "title-sky-blue"
                      : "title-gray")
                  }
                >
                  <span>YEAR {this.year3}</span>
                  {this.year3 === this.currentYear && (
                    <span className="block">(CURRENT YEAR)</span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center">
                <th className="sub-title title-sky-blue"></th>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">Expected</div>
                    <div className="col-xs-4">Actual</div>
                    <div className="col-xs-4 make-it-bolder">Diff</div>
                  </div>
                </td>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">Expected</div>
                    <div className="col-xs-4">Actual</div>
                    <div className="col-xs-4 make-it-bolder">Diff</div>
                  </div>
                </td>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">Expected</div>
                    <div className="col-xs-4">Actual</div>
                    <div className="col-xs-4 make-it-bolder">Diff</div>
                  </div>
                </td>
              </tr>
              {this.state.grossProfitsExpanded === true && (
                <tr className="text-center">
                  <th className="sub-title title-sky-blue">Revenues</th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4 make-it-bolder">&nbsp;</div>
                    </div>
                  </td>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4 make-it-bolder">&nbsp;</div>
                    </div>
                  </td>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4 make-it-bolder">&nbsp;</div>
                    </div>
                  </td>
                </tr>
              )}
              {this.state.grossProfitsExpanded === true &&
                this.state.totalRevenuesExpanded === true && (
                  <tr className="text-center">
                    <th className="description">Units</th>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedUnits1}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualUnits1}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffUnits1}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedUnits2}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualUnits2}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffUnits2}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="row">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedUnits3}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualUnits3}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffUnits3}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              {this.state.grossProfitsExpanded === true &&
                this.state.totalRevenuesExpanded === true && (
                  <tr className="text-center">
                    <th className="description">Average Selling Price</th>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedAvgSellingPrice1}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualAvgSellingPrice1}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffAvgSellingPrice1}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedAvgSellingPrice2}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualAvgSellingPrice2}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffAvgSellingPrice2}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="row">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedAvgSellingPrice3}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualAvgSellingPrice3}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffAvgSellingPrice3}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              {this.state.grossProfitsExpanded === true && (
                <tr className="text-center bg-gray none-shadow">
                  <th className="description">
                    <strong>Total Revenues</strong>
                    {this.state.totalRevenuesExpanded === false ? (
                      <span
                        className="fn-analysis-plus"
                        onClick={this.expandTotalRevenues}
                      >
                        +
                      </span>
                    ) : (
                      <span
                        className="fn-analysis-minus"
                        onClick={this.collapseTotalRevenues}
                      >
                        -
                      </span>
                    )}
                  </th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalRevenues1}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalRevenues1}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalRevenues1}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalRevenues2}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalRevenues2}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalRevenues2}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="row">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalRevenues3}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalRevenues3}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalRevenues3}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {this.state.grossProfitsExpanded === true && (
                <tr className="text-center">
                  <th className="sub-title title-sky-blue">Cost of Sales</th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4 make-it-bolder">&nbsp;</div>
                    </div>
                  </td>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4 make-it-bolder">&nbsp;</div>
                    </div>
                  </td>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4 make-it-bolder">&nbsp;</div>
                    </div>
                  </td>
                </tr>
              )}
              {this.state.grossProfitsExpanded === true &&
                this.state.totalCostOfSalesExpanded === true && (
                  <tr className="text-center">
                    <th className="description">Units</th>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedUnits1}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualUnits1}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffUnits1}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedUnits2}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualUnits2}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffUnits2}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="row">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedUnits3}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualUnits3}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffUnits3}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              {this.state.grossProfitsExpanded === true &&
                this.state.totalCostOfSalesExpanded === true && (
                  <tr className="text-center">
                    <th className="description">Average Unit Costs</th>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedAvgUnitCosts1}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualAvgUnitCosts1}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffAvgUnitCosts1}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedAvgUnitCosts2}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualAvgUnitCosts2}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffAvgUnitCosts2}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="row">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedAvgUnitCosts3}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualAvgUnitCosts3}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffAvgUnitCosts3}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              {this.state.grossProfitsExpanded === true && (
                <tr className="text-center bg-gray none-shadow">
                  <th className="description">
                    <strong>Total Cost of Sales</strong>
                    {this.state.totalCostOfSalesExpanded === false ? (
                      <span
                        className="fn-analysis-plus"
                        onClick={this.expandTotalCostOfSales}
                      >
                        +
                      </span>
                    ) : (
                      <span
                        className="fn-analysis-minus"
                        onClick={this.collapseTotalCostOfSales}
                      >
                        -
                      </span>
                    )}
                  </th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalCostOfSales1}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalCostOfSales1}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalCostOfSales1}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalCostOfSales2}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalCostOfSales2}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalCostOfSales2}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="row">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalCostOfSales3}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalCostOfSales3}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalCostOfSales3}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="text-center bg-gray none-shadow">
                <th className="description">
                  <strong>Gross Profits</strong>
                  {this.state.grossProfitsExpanded === false ? (
                    <span
                      className="fn-analysis-plus"
                      onClick={this.expandGrossProfits}
                    >
                      +
                    </span>
                  ) : (
                    <span
                      className="fn-analysis-minus"
                      onClick={this.collapseGrossProfits}
                    >
                      -
                    </span>
                  )}
                </th>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.expectedGrossProfits1}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.actualGrossProfits1}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4 make-it-bolder">
                      <AbbreviatedMillionNumberFormat
                        value={this.diffGrossProfits1}
                        prefix=""
                        negativeClass="title-red"
                        suffix="%"
                        hideZero={true}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.expectedGrossProfits2}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.actualGrossProfits2}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4 make-it-bolder">
                      <AbbreviatedMillionNumberFormat
                        value={this.diffGrossProfits2}
                        prefix=""
                        negativeClass="title-red"
                        suffix="%"
                        hideZero={true}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div className="row">
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.expectedGrossProfits3}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.actualGrossProfits3}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4 make-it-bolder">
                      <AbbreviatedMillionNumberFormat
                        value={this.diffGrossProfits3}
                        prefix=""
                        negativeClass="title-red"
                        suffix="%"
                        hideZero={true}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              {this.state.netProfitsExpanded === true && (
                <tr className="text-center">
                  <th className="description">Other Expenses</th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedOperatingExpenses1}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualOperatingExpenses1}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffOperatingExpenses1}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedOperatingExpenses2}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualOperatingExpenses2}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffOperatingExpenses2}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="row">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedOperatingExpenses3}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualOperatingExpenses3}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffOperatingExpenses3}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {this.state.netProfitsExpanded === true && (
                <tr className="text-center bg-gray none-shadow">
                  <th className="description">
                    <strong>Total Income Before Taxes</strong>
                  </th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalIncomeBeforeTaxes1}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalIncomeBeforeTaxes1}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalIncomeBeforeTaxes1}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalIncomeBeforeTaxes2}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalIncomeBeforeTaxes2}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalIncomeBeforeTaxes2}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="row">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalIncomeBeforeTaxes3}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalIncomeBeforeTaxes3}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalIncomeBeforeTaxes3}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="text-center bg-gray none-shadow">
                <th className="description">
                  <strong>Net Profits</strong>
                  {this.state.netProfitsExpanded === false ? (
                    <span
                      className="fn-analysis-plus"
                      onClick={this.expandNetProfits}
                    >
                      +
                    </span>
                  ) : (
                    <span
                      className="fn-analysis-minus"
                      onClick={this.collapseNetProfits}
                    >
                      -
                    </span>
                  )}
                </th>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.expectedNetProfits1}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.actualNetProfits1}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4 make-it-bolder">
                      <AbbreviatedMillionNumberFormat
                        value={this.diffNetProfits1}
                        prefix=""
                        negativeClass="title-red"
                        suffix="%"
                        hideZero={true}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.expectedNetProfits2}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.actualNetProfits2}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4 make-it-bolder">
                      <AbbreviatedMillionNumberFormat
                        value={this.diffNetProfits2}
                        prefix=""
                        negativeClass="title-red"
                        suffix="%"
                        hideZero={true}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div className="row">
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.expectedNetProfits3}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.actualNetProfits3}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4 make-it-bolder">
                      <AbbreviatedMillionNumberFormat
                        value={this.diffNetProfits3}
                        prefix=""
                        negativeClass="title-red"
                        suffix="%"
                        hideZero={true}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default VarianceAnalysis;



// WEBPACK FOOTER //
// ./src/components/finance/analysis/variance-analysis.js